export default class Filter {
    public init() {
        this.changeSelected();
    }

    public changeSelected(){
        const $selectBox = $('.filter-box select');

        $selectBox.on('change',function(e) {
            (window as any).location.href = $(this).val();
        })
    }
}